export enum UserRole {
	Admin = 'admin',
	Mentor = 'mentor',
	User = 'user',
	Bot = 'bot',
	LlmBot = 'llm_bot',
}
